import router from "../router";


export const typeOpt = (row) => {
  if(row.type == 1) {
    return {
      name: "新闻",
      router: "/show/news",
      color: "",
      query: {
        id: row.id
      }
    }
  } else if(row.type == 2) {
    return {
      name: "图集",
      router: "/atlas",
      color: "",
      query: {
        id: row.id
      }
    }
  } else if(row.type == 4) {
    return {
      name: "视频",
      router: "/show/video",
      color: "",
      query: {
        id: row.id
      }
    }
  } else if(row.type == 5) {
    return {
      name: "专题",
      router: "/special",
      color: "",
      query: {
        id: row.id
      }
    }
  } else if(row.type == 6) {
    return {
      name: "视频专题",
      router: "/show/videoList",
      color: "",
      query: {
        id: row.id
      }
    }
  } else if(row.type == 8) {
    return {
      name: "投票",
      router: "/show/vote",
      color: "#0FBB57",
      query: {
        id: row.id
      }
    }

  } else if(row.type == 20) {
    return {
      name: "学校",
      router: "/show/venue",
      color: "",
      query: {
        id: row.id,
        type: row.type
      }
    }
  } else if(row.type == 21) {
    return {
      name: "场馆",
      router: "/show/venue",
      color: "",
      query: {
        id: row.id,
        type: row.type
      }
    }
  } else if(row.type == 22) {
    return {
      name: "课程",
      router: "/course/show",
      color: "",
      query: {
        id: row.aid || row.id
      }
    }
  } else if(row.type == 23) {
    return {
      name: "老师",
      router: "/show/teacher",
      color: "",
      query: {
        id: row.tid
      }
    }
  } else if(row.type == 26 || row.type == 11 || row.type == 12) {
    return {
      name: "活动",
      router: "/show/active",
      color: "#FF8913",
      query: {
        id: row.id || row.articleid
      }
    }
  } else if(row.type == 28) { // 普通直播
    return {
      name: "直播",
      router: "/show/live",
      color: "",
      query: {
        id: row.id
      }
    }
  } else if(row.type == 29) { 
    return {
      name: "慕课",
      router: "/study/mooc/show",
      color: "",
      query: {
        id: row.id
      }
    }
  } else if(row.type == 30) { 
    return {
      name: "vr",
      router: "/vr/show",
      color: "",
      query: {
        id: row.id
      }
    }
  } else if(row.type == 40) { 
    return {
      name: "直播教室",
      router: "/study/live/show",
      color: "",
      query: {
        id: row.id
      }
    }
  }
}

export const openInfo = (row) => {
  // if (row.funid) {
  //   window.location.href = funid
  //   return
  // }
  router.push({
    path: typeOpt(row).router,
    query: typeOpt(row).query
  })
} 